module.exports = "/_next/static/images/bank-permata-icon-7c9288478eaf496fd94d0cc37eb32545.svg";